import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import CinemapSlider from '../../../../SHARED/components/slider/slider.component';
import { requestSliderNews } from '../../../../SHARED/actions/news.actions';
import {slugify} from "../../../../SHARED/helpers/general.helper";
import Parser from "html-react-parser";


class SliderHomeContainer extends Component {

    componentWillMount() {
        this.props.requestSliderNews()
    }

    getSlides() {
        return this.props.sliderNews;
    }

    render() {
        const slides = this.getSlides();

        const items = [];
        let itemLink = '';

        slides.map((item, i) => {
            switch(item.featured_type)
            {
                case 'cinema':
                    itemLink = '/program/' + item.featured_cinema;
                break;

                case 'film':
                    itemLink = '/film/' + item.featured_film + '/' + slugify(item.featured_title);
                break;

                case 'articol':
                    itemLink = '/stire/' + item.featured_articol + '/' + slugify(item.featured_title);
                break;

                case 'festival':
                    itemLink = '/festival/' + item.featured_festival + '/' + slugify(item.featured_title);
                break;
                default:
                break;
            }


            items.push({
                key: i,
                article_title: item.featured_title,
                article_summary: item.featured_description,
                item_link: itemLink,
                article_image: Parser(item.featured_image),
                subtitle: item.featured_subtitle
            });
        });

        return (
            <div className="sliderHomeContainer">
                <CinemapSlider slides={items}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    sliderNews: state.news.sliderNews
});
export default connect(mapStateToProps, {requestSliderNews})(SliderHomeContainer);



// WEBPACK FOOTER //
// ./src/FO/components/home/containers/sliderhomecontainer.component.js